import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/app-root/src/layouts/default.vue").then(m => m.default || m))
}